import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import parse from 'html-react-parser'

interface Info {
  id: number
  title: string
  alt: string
  width: number
  height: number
  image: {
    url: string
  }[]
}

const s = {
  container: `relative w-full h-fit-content -mt-4`,
  flex: `flex flex-row items-start mb-8 last:mb-0`,
  image: `w-9 h-9 mr-3 filtercolor`,
  title: `mb-0 capitalize`,
}

const Info = () => {
  const datas = useStaticQuery(graphql`
    query {
      allFlamelinkInfoContent(
        sort: { fields: _fl_meta____createdDate, order: ASC }
      ) {
        nodes {
          id
          title
          alt
          width
          height
          image {
            url
          }
        }
      }
    }
  `)

  const infos = datas.allFlamelinkInfoContent.nodes

  return (
    <section className={s.container}>
      {infos.map(({ id, title, alt, width, height, image }: Info) => (
        <div className={s.flex} key={id}>
          <img
            className={s.image}
            src={image[0].url}
            alt={alt}
            width={width}
            height={height}
          />
          <div className={s.title}>{parse(title)}</div>
        </div>
      ))}
    </section>
  )
}

export default Info
